<div class="container-fluid padding-zero">
    <router-outlet></router-outlet>
</div>
